//引入vue
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
import ProductDiary from "@/page/Product/ProductDiary";
import Today from "@/page/Today/Today";
import Orders from "@/page/Order/Orders";
import Products from "@/page/Product/Products";
import ProductDetail from "@/page/Product/ProductDetail";
import Login from "@/page/Login/Login";
import Home from "@/page/Home/Home";
import Groups from "@/page/Group/Groups";
import StoreManager from "@/page/Store/StoreManager";
import KeywordManager from "@/page/Keyword/KeywordManager";
import Dashboard from "@/page/Dashboard/Dashboard";
import QuotationManager from "@/page/Provider/QuotationManager";
import QuotationSearcher from "@/page/Provider/QuotationSearcher";
import providerManager from "@/page/Provider/ProviderManager";
import requestManager from "@/page/Request/RequestManager";
import WebsiteManager from "@/page/Website/WebsiteManager";
//第三方库需要use一下才能用
Vue.use(VueRouter)
const routes = [
    {path: "/", redirect: "/home/quotation/search"},
    {
        path: "/home",
        component: Home,
        children: [
            {path: "dashboard", component: Dashboard},
            {path: "today", component: Today},
            {path: "diaries", component: ProductDiary},
            {path: "products/:sku/diary", component: ProductDiary},
            {path: "orders", component: Orders},
            {path: "orders/:sku", component: Orders},
            {path: "products", component: Products},
            {path: "products/:productId", component: ProductDetail},
            {path: "groups", component: Groups},
            {path: "stores", component: StoreManager},
            {path: "keyword", component: KeywordManager},
            {path: "quotation/quotations", component: QuotationManager},
            {path: "quotation/search", component: QuotationSearcher},
            {path: "quotation/provider", component: providerManager},
            {path: 'request', component: requestManager},
            {path: 'website', component: WebsiteManager}
        ]
    },
    {path: "/login", component: Login}
]

const router = new VueRouter({
    routes
});


router.beforeEach((to, from, next) => {
    Vue.prototype.$bus.$emit("closeMsg");

    // 路由变化时取消当前所有非全局的pending状态的请求
    Vue.prototype.$axios.clearPendingPool();
    if (to.path !== "/login" && !localStorage.token) {
        next({path: "/login"});
    } else {
        next();
    }
});


export default router;